<template>
  <div class="pb-7" v-if="!loaded">
    <div class="info-panel" v-if="fieldSettings">
      <div v-if="errorMessage" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-5">
        <div class="d-flex flex-column text-light pe-0 pe-sm-10">
          <span v-html="errorMessage"></span>
        </div>
      </div>
      <div class="text-gray-700 fw-bold mb-3 ms-2">Общие данные</div>
      <div class="row">
        <div class="col-md-4" v-if="fieldSettings.iin.show || (isCreateClient() && fieldSettings.iin.required)">
          <input-mask-field
            v-model="data.client.iin"
            id="client.iin"
            name="client_iin"
            :required="fieldSettings.iin.required"
            :disabled="fieldSettings.iin.disabled"
            :mb="5"
            mask="### ### ### ###"
            :placeholder="this.data.filter.person ? 'ИИН' : 'БИН'"
            type="text"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.surname.show || (isCreateClient() && fieldSettings.surname.required)">
          <input-field
            v-model="data.client.surname"
            id="client.surname"
            name="client_surname"
            :required="fieldSettings.surname.required"
            :disabled="fieldSettings.surname.disabled && !isCreateClient()"
            placeholder="Фамилия"
            type="text"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.name.show || (isCreateClient() && fieldSettings.name.required)">
          <template v-if="this.data.filter.person">
            <input-field
                v-model="data.client.name"
                id="client.name"
                name="client_name"
                :required="fieldSettings.name.required"
                :disabled="fieldSettings.name.disabled && !isCreateClient()"
                placeholder="Имя"
                type="text"
                mb="5"
            />
          </template>
          <template v-else>
            <area-field
                v-model="data.client.name"
                id="client.name"
                name="client_name"
                :required="fieldSettings.name.required"
                :disabled="fieldSettings.name.disabled && !isCreateClient()"
                :class="'h-125px'"
                class="h-auto"
                placeholder="Наименование"
                type="text"
                mb="5"
            />
          </template>
        </div>
        <div class="col-md-4" v-if="fieldSettings.patronymic.show || (isCreateClient() && fieldSettings.patronymic.required)">
          <input-field
            v-model="data.client.patronymic"
            :required="fieldSettings.patronymic.required"
            :disabled="fieldSettings.patronymic.disabled && !isCreateClient()"
            id="client.patronymic"
            name="client_patronymic"
            placeholder="Отчество"
            type="text"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.birthday.show || (isCreateClient() && fieldSettings.birthday.required)">
          <date-field
            v-model="data.client.birthday"
            :required="fieldSettings.birthday.required"
            :disabled="fieldSettings.birthday.disabled && !isCreateClient()"
            id="client.birthday"
            name="client_birthday"
            :placeholder="data.filter.person ? 'Дата рождения' : 'Дата регистрации'"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.sex.show || (isCreateClient() && fieldSettings.sex.required)">
          <select-field
            v-model="data.client.sex"
            :required="fieldSettings.sex.required"
            :disabled="fieldSettings.sex.disabled && !isCreateClient()"
            id="client.sex"
            name="client_sex"
            :options="{1:'Мужской', 2:'Женский'}"
            placeholder="Пол"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.phone.show || (isCreateClient() && fieldSettings.phone.required)">
          <input-mask-field
            v-model="data.client.phone"
            id="client.phone"
            name="client_phone"
            :required="fieldSettings.phone.required"
            :disabled="fieldSettings.iin.disabled"
            :mb="5"
            placeholder="Сотовый номер"
            mask="+7(###) ###-####"
            type="text"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.email.show || (isCreateClient() && fieldSettings.email.required)">
          <input-field
            v-model="data.client.email"
            :required="fieldSettings.email.required"
            :disabled="fieldSettings.email.disabled && !isCreateClient()"
            id="client.email"
            name="client_email"
            :placeholder="'Эл.почта'"
            :has-error="!validEmail"
            type="email"
            :mb="!validEmail ? '2' : '5'"
          />
        </div>
        <div class="col-md-4 d-flex align-items-center justify-content-start">
          <p v-if="!validEmail" class="text-danger">Некорректный email</p>
        </div>
      </div>
      <div class="text-gray-700 fw-bold mb-3 ms-2">Адрес</div>
      <div class="row">
        <div class="col-12" v-if="fieldSettings.country_id.show || (isCreateClient() && fieldSettings.country_id.required)">
          <select-field
            v-model="data.location.country_id"
            :required="fieldSettings.country_id.required"
            :disabled="fieldSettings.country_id.disabled && !isCreateClient() && data.location.country_id !== 0"
            id="location.country_id"
            name="location.country_id"
            :options="this.countries"
            placeholder="Страна резиденства"
            mb="5"
          />
        </div>
        <div class="col-12" v-if="fieldSettings.address.show || (isCreateClient() && fieldSettings.address.required)">
          <area-field
            v-model="data.location.address"
            :required="fieldSettings.address.required"
            :disabled="fieldSettings.address.disabled && !isCreateClient()"
            id="location.address"
            name="location.address"
            :class="'h-125px'"
            :placeholder="this.data.filter.person ? 'Адрес' : 'Юридический адрес'"
            type="text"
            mb="5"
          />
        </div>
      </div>
      <div class="text-gray-700 fw-bold mb-3 ms-2" v-if="fieldSettings.type_id.show">Документ</div>
      <div class="row">
        <div class="col-md-4" v-if="fieldSettings.type_id.show || (isCreateClient() && fieldSettings.type_id.required)">
          <select-field
            v-model="data.document.type_id"
            :required="fieldSettings.type_id.required"
            :disabled="fieldSettings.type_id.disabled && !isCreateClient()"
            id="document.type"
            name="document_type"
            :options="this.types"
            placeholder="Вид документа"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.number.show || (isCreateClient() && fieldSettings.number.required)">
          <input-field
            v-model="data.document.number"
            :required="fieldSettings.number.required"
            :disabled="fieldSettings.number.disabled && !isCreateClient()"
            id="document.number"
            name="document_number"
            placeholder="Номер документа"
            type="text"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.issued.show || (isCreateClient() && fieldSettings.issued.required)">
          <date-field
            v-model="data.document.issued"
            :required="fieldSettings.issued.required"
            :disabled="fieldSettings.issued.disabled && !isCreateClient()"
            id="document.date"
            name="document_date"
            :placeholder="this.data.filter.person ? 'Дата выдачи документа' : 'Дата первичной регистрации'"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.until.show || (isCreateClient() && fieldSettings.until.required)">
          <date-field
            v-model="data.document.until"
            :required="fieldSettings.until.required"
            :disabled="fieldSettings.until.disabled && !isCreateClient()"
            id="data.document.until"
            name="data.document.until"
            placeholder="Дата завершения"
            mb="5"
          />
        </div>
        <div class="col-md-8" v-if="fieldSettings.issuer.show || (isCreateClient() && fieldSettings.issuer.required)">
          <input-field
            v-model="data.document.issuer"
            :required="fieldSettings.issuer.required"
            :disabled="fieldSettings.issuer.disabled && !isCreateClient()"
            id="data.document.issuer"
            name="data.document.issuer"
            placeholder="Кем выдано"
            type="text"
            mb="5"
          />
        </div>
      </div>
      <div class="text-gray-700 fw-bold mb-3 ms-2" v-if="fieldSettings.licence_number.show && data.licence">Водительское удостоверение</div>
      <div class="row">
        <div class="col-md-4" v-if="fieldSettings.licence_number.show && data.licence?.number">
          <input-field
            v-model="data.licence.number"
            :required="false"
            :disabled="true"
            id="licence.number"
            name="licence_number"
            placeholder="Номер документа"
            type="text"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.licence_issued.show && data.licence?.issued">
          <date-field
            v-model="data.licence.issued"
            :required="false"
            :disabled="true"
            id="licence.issued"
            name="licence_issued"
            placeholder="Дата выдачи документа"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.licence_until.show && data.licence?.until">
          <date-field
            v-model="data.licence.until"
            :required="false"
            :disabled="true"
            id="licence.until"
            name="licence_until"
            placeholder="Дата завершения"
            mb="5"
          />
        </div>
        <div class="col-md-4" v-if="fieldSettings.licence_categories && data.licence?.categories">
          <input-field
            v-model="licenceCategories"
            :required="false"
            :disabled="true"
            placeholder="Категория"
            id="licence.categories"
            name="licence_categories"
          />
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-6">
          <button @click="closeClientData" type="button" class="btn btn-sm btn-warning w-100">Отменить</button>
        </div>
        <div class="col-6">
          <button @click="setClient" type="button" :disabled="!valid || !validEmail || errorMessage.length > 0" class="btn btn-sm btn-primary w-100" v-html="Object.keys(this.dataClient).length !== 0 ? 'Обновить' : 'Создать'"></button>
        </div>
      </div> -->
    </div>
  </div>
  <loader-full v-else style="height: 400px"/>
</template>

<script>
// Fields
import InputMaskField       from '@/components/Fields/InputMaskField'
import SelectField          from '@/components/Fields/SelectField'
import InputField           from '@/components/Fields/InputField'
import DateField            from '@/components/Fields/DateField'
// Modules
import LoaderFull from '@/components/Main/LoaderFull'
import AreaField  from '@/components/Fields/AreaField'
import axios      from 'axios';

export default {
  name: 'CustomerBpmData',
  props: {
    searchData: {
      type: Object,
      default: null
    },
    dataClient: {
      type: Object,
      default: () => ({})
    },
    isClear: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    module: {
      typ: Function,
      required: true
    },
    mode: {
      type: [Object, Function],
      required: true
    }
  },
  components: {AreaField, LoaderFull, SelectField, DateField, InputField, InputMaskField },
  emits: ['update-client-data', 'close-client-data'],
  data () {
    return {
      data: this.module.Client.empty(),
      fieldSettings:      null,
      validEmail:         false,
      filterStep:         0,
      countries:          null,
      typeName:           '',
      loaded:             false,
      types:              null,
      valid:              false,
      errorMessage:       ''
    }
  },
  mounted() {
    this.getCountries()
    if (this.types && this.data.document) this.typeName = this.types[this.data.document.type_id]
    this.valid = this.isValidObject(this.fieldSettings, this.flattenToValues(this.data))
  },
  computed: {
    licenceCategories() {
      return this.data.licence?.categories?.join(', ')
    }
  },
  methods: {
    closeClientData() {
      this.$emit('close-client-data', 1)
    },
    updateClientData(data) {
      this.$emit('update-client-data', data)
    },
    getCountries() {
      axios.get('/api/dictionaries/countries')
          .then(res => {
            this.countries = res.data
          })
    },
    setClient() {
      this.$emit('set-client', this.data)
    },
    flattenToValues(obj) {
      return this.module.Client.flattenToValues(obj)
    },
    isValidObject(rules, data) {
      if (typeof rules !== 'object' || rules === null || typeof data !== 'object' || data === null) {
        return false;
      }

      return Object.entries(rules).every(([field, properties]) => {
        if (!properties.required) return true
        const value = data[field]
        return value !== null && value !== undefined && value !== ''
      });
    },
    isCreateClient() {
      const hasSearchResult = !!(this.searchData && Object.prototype.hasOwnProperty.call(this.searchData, 'result'))
      return !(this.dataClient.filter) && !hasSearchResult
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(newValue) {
        const modeCtx = { mode: this.mode }
        this.fieldSettings = this.module.Client.dataFieldsSettings(newValue.filter.resident, newValue.filter.person, modeCtx)
        if (newValue.location.country_id === 0 && newValue.filter.resident) newValue.location.country_id = 1
        this.filterStep = this.module.Client.filterStep(newValue.filter)
        if (!this.fieldSettings && ((newValue.document?.number && newValue.filter.person) || (!newValue.filter.person))) {
          this.fieldSettings = this.module.Client.recalculateDisabledFields(this.module.Client.fieldsSettings(newValue.filter.resident, newValue.filter.person), newValue)
        }
        this.valid = this.isValidObject(this.fieldSettings, this.flattenToValues(newValue))
      }
    },
    'data.client.iin': {
      immediate: true,
      handler(newValue) {
        if (newValue) this.data.client.iin = newValue.toString().replace(/\D/g, '');
      }
    },
    'data.document.type_id' : {
      deep: true,
      handler(newValue) {
        this.typeName = this.types[newValue]
      }
    },
    'data.filter': {
      deep: true,
      handler (newValue) {
        this.filterStep = this.module.Client.filterStep(newValue)
      }
    },
    'data.client.email': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            newValue = newValue.replace(/[^a-zA-Z0-9@._+-]/g, '');
            const parts = newValue.split('@');
            if (parts.length > 2) {
              newValue = parts.shift() + '@' + parts.join('');
            }
            newValue = newValue.replace(/@[^a-zA-Z0-9.-].*/, '@');
            this.data.client.email = newValue;

            const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            this.validEmail = !newValue || emailRegex.test(newValue);
          })
        } else {
          this.validEmail = true;
        }
      }
    },
    filterStep: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.types = this.module.Client.documentType(newValue)
      }
    },
    dataClient: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          if (newValue.client) {
            Object.entries(newValue.client).forEach(([key, value]) => {
              if (Object.prototype.hasOwnProperty.call(this.data.client, key)) this.data.client[key] = structuredClone(value)
            });
            if (!this.data.client.name) this.data.client.name = newValue.client.title
          }
          if (newValue.document) {
            Object.entries(newValue.document).forEach(([key, value]) => {
              if (Object.prototype.hasOwnProperty.call(this.data.document, key)) this.data.document[key] = structuredClone(value)
            });
          }
          if (newValue.location) {
            Object.entries(newValue.location).forEach(([key, value]) => {
              if (Object.prototype.hasOwnProperty.call(this.data.location, key)) this.data.location[key] = structuredClone(value)
            });
          }
          if (newValue.filter) this.data.filter = structuredClone(newValue.filter)
          if (newValue.documents) this.data.documents = structuredClone(newValue.documents)
          if (newValue.licence) this.data.licence = structuredClone(newValue.licence)
        }
      }
    },
    searchData: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!newValue) return

        const filter = (newValue.filter && typeof newValue.filter === 'object') ? newValue.filter : {}
        const client = (newValue.client && typeof newValue.client === 'object') ? newValue.client : {}

        this.data.filter = {
          ...this.data.filter,
          ...filter
        }

        Object.entries(client).forEach(([key, value]) => {
          if (Object.prototype.hasOwnProperty.call(this.data.client, key)) {
            this.data.client[key] = value
          }
        });

        this.fieldSettings = this.module.Client.dataFieldsSettings(
          !!this.data.filter.resident, !!this.data.filter.person,
          { mode: this.mode }
        )
      }
    },
  }
}
</script>

<style scoped>

</style>